export default __webpack_public_path__ + "static/media/results_recently.b8cd0614.png";